export const isDevelopmentEnvironment = (): boolean => {
	return import.meta.env.VITE_RUN_ENV === 'development';
};

/**
 * `true` only when the app is running as a Playwright e2e target: a `--mode ci`
 * build served from localhost. The hostname guard is defence in depth — the
 * PrivateRoute bypass this gates skips Auth0 entirely, so a `dist-ci/` bundle
 * accidentally served from a non-localhost origin (dev slip, future preview
 * deploy) must fail closed and fall through to the real login flow.
 */
export const isCIEnvironment = (): boolean => {
	if (import.meta.env.VITE_RUN_ENV !== 'ci') {
		return false;
	}

	if (typeof window === 'undefined') {
		return true;
	}

	const { hostname } = window.location;
	return hostname === 'localhost' || hostname === '127.0.0.1';
};
